// extracted by mini-css-extract-plugin
export default {"selector":"PoolSelector_selector__niHf7","item":"PoolSelector_item__CAR+s","algo":"PoolSelector_algo__CI0cl","label":"PoolSelector_label__2sZ4+"};